import { request } from '@/shared/api/request'
export const downloadLaborRecords = (withPhoto) =>
	request({
		url: `contract/labor/laborRecordsData/pdf/?withPhoto=${withPhoto}`,
		method: 'GET',
		responseType: 'blob',
	})
